import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers/settingsNavPathV3";

import { t } from "@/i18n-js/instance";
import { useIsPlusCommandCenterEnabled } from "@/react/components/SettingsApp/PlusCommandCenter/useIsPlusCommandCenterEnabled";
import { useBrandedAppsFeatureFlags } from "@/react/hooks/useBrandedAppsFeatureFlags";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const useBrandedAppsDashboardLinks = (): Link[] => {
  const links: Link[] = [];

  const { brandedAppsBuilder } = useBrandedAppsFeatureFlags();
  const isCommandCenterEnabled = useIsPlusCommandCenterEnabled();

  // if community is not on Plus Custom plan, show the PlusLiteDashboard and the landing page
  if (!brandedAppsBuilder.isEnabled) {
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.lite"),
      path: settingsNavPathV3.plus.lite,
      exact: true,
    });
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.customize"),
      path: settingsNavPathV3.plus.landing_page,
      exact: true,
    });
  }

  if (brandedAppsBuilder.isEnabled && isCommandCenterEnabled) {
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.command_center"),
      path: settingsNavPathV3.plus.index,
      exact: true,
    });
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.app_settings"),
      path: settingsNavPathV3.plus.app_settings,
      exact: true,
    });
  }

  if (brandedAppsBuilder.isEnabled && !isCommandCenterEnabled) {
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.customize"),
      path: settingsNavPathV3.plus.index,
      exact: true,
    });
  }

  links.push({
    label: t("settings_nav_v3.branded_apps_dashboard.push_notifications"),
    path: settingsNavPathV3.plus.push_notifications,
    exact: true,
  });

  return links;
};

export const BrandedAppsDashboardLinks = () => {
  const links = useBrandedAppsDashboardLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content
        title={t("settings_nav_v3.branded_apps_dashboard.title")}
      >
        {links.map(link => (
          <SubNavLinkItem
            isDisabled={link.isDisabled}
            key={link.path}
            label={link.label}
            to={link.path}
          />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
